"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MusicTrack_1 = __importDefault(require("../../classes/MusicTrack"));
const getDefinables_1 = __importDefault(require("./getDefinables"));
const getMusicTracks = () => {
    const musicTracks = new Map;
    (0, getDefinables_1.default)("MusicTrack").forEach((musicTrack) => {
        const slug = musicTrack.slug;
        if (musicTrack instanceof MusicTrack_1.default) {
            musicTracks.set(slug, musicTrack);
        }
    });
    return musicTracks;
};
exports.default = getMusicTracks;
